export default __webpack_public_path__ + "static/aggregation-d341527b38c0b06a173aef12ea2ccd7d.gif";